import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Anchor from '../../commonComponents/Anchor';
import translate from '../../commonComponents/translate';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';
import GoogleAnalytics, {
  ENROLL_SOURCE,
  ENROLL_TYPE,
} from '../../services/googleAnalytics';
import CourseProp from './propTypes/courseProp';

function EnrollButton({ t, course, onClick, className, source }) {
  const { loggedUser } = useContext(LoggedUserContext);
  const showButton = loggedUser && onClick;

  const enrollInfo = {
    event: ENROLL_TYPE.COURSE,
    name: course.name,
    source,
    isLogged: !!loggedUser,
  };
  const handleClick = () => {
    GoogleAnalytics.enrollClicked(
      enrollInfo.event,
      enrollInfo.name,
      enrollInfo.source,
      enrollInfo.isLogged,
    );
    onClick();
  };

  const fullClassNames = `btn m-btn--pill btn-dynamic ${className}`;

  return showButton ? (
    <button type="button" className={fullClassNames} onClick={handleClick}>
      {t('academy_enroll')}
    </button>
  ) : (
    <Anchor
      href={`/academy/${course.slug}/enroll`}
      className={fullClassNames}
      itemProp="url"
      enrollInfo={enrollInfo}
    >
      {t('academy_enroll')}
    </Anchor>
  );
}

EnrollButton.propTypes = {
  t: PropTypes.func.isRequired,
  course: PropTypes.shape(CourseProp.propType),
  onClick: PropTypes.func,
  className: PropTypes.string,
  source: PropTypes.oneOf(Object.values(ENROLL_SOURCE)),
};

EnrollButton.defaultProps = {
  course: null,
  onClick: null,
  source: ENROLL_SOURCE.DETAIL,
  className: 'enroll-button',
};

export default translate(EnrollButton);
